/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../../../common';
import Component from 'flarum/common/Component';
import categorizeUserAchievements from '../utils/categorizeUserAchievements';
import UserAchievementsCategory from './UserAchievementsCategory';

// Make translation calls shorter
const t = (...args) => app.translator.trans(...args);
const prfx = `${slug}.forum.user`;

export default class UserAchievementList extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const categories = categorizeUserAchievements(this.attrs.user);

		return (
			<div className="UserAchievements">
				{categories.length === 0 && (
					<div className="Placeholder">
						<p>{t(`${prfx}.no_achievements`)}</p>
					</div>
				)}

				{categories.length >= 1 &&
					categories.map(({ category, userAchievements }) => {
						return <UserAchievementsCategory category={category} userAchievements={userAchievements} user={this.attrs.user} />;
					})}
			</div>
		);
	}
}
